import { render, staticRenderFns } from "./MaxSales.vue?vue&type=template&id=4a422252"
import script from "./MaxSales.vue?vue&type=script&lang=js"
export * from "./MaxSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports